<template>
  <catalog-selection class="car-form-container car-vehicle-identification-catalog" :display-submit-btn="false" :prop-array="propArray" :goNext="goNext">
    <template v-slot:submitBtn="slotProps">
      <div class="car-form-error-message " v-if="requestError">{{ $t('errors.unknown') }}</div>
      <div class="car-form-buttons car-buttons">
        <primary-btn @click="slotProps.submitForm"
                     class="car-btn-primary"
                     :loading="slotProps.loading"
                     data-js="catalog-identification__container--btn">
          {{ $t('catalogSelection.mainBtn') }}
        </primary-btn>
        <div class="car-form-required">* {{ $t('catalogSelection.requiredNote') }}</div>
      </div>
    </template>
  </catalog-selection>
</template>

<script>
import { mapMutations } from 'vuex';
import smpConfigUtil from '@/util/smp_config_utils';
import regionService from '@/services/regionService';
import PrimaryBtn from '@/components/PrimaryBtn';

export default {
  name: 'CatalogIdentification',
  components: { PrimaryBtn },
  data: function() {
    return {
      requestError: false,
      propArray: ['vehicleCategory', 'brand', 'year', 'month', 'fuelType', 'serie', 'model', 'engine', 'mileage']
    }
  },
  methods: {
    ...mapMutations('vehicleEquipments', {
      setEquipments: 'SET_SELECTED_EQUIPMENTS'
    }),
    goNext(stateObj) {
      this.requestError = false;
      // set engine and fuel as selectedEquipments
      let selectedEquipments = [];
      selectedEquipments.push(stateObj.engine.value);
      selectedEquipments.push(stateObj.fuelType.value);
      this.setEquipments(selectedEquipments);

      if (stateObj.mileage.value) this.$store.dispatch('wizardData/setMileageData', stateObj.mileage.value);

      // set vehicleType
      return this.$store.dispatch('vehicleIdentification/getVehicle')
        .then(() => regionService.nextRoute(this))
        .catch(() => { this.requestError = true; })
    }
  },
  beforeRouteEnter(to, from, next) {
    return next(vm => {
      if (!smpConfigUtil.isVehicleSelectionMethodAllowed(smpConfigUtil.VEHICLE_SELECTION_CATALOG)) {
        vm.$router.push({ name: 'VehicleIdentification' });
      }
    })
  }
}
</script>
